import Vue from 'vue';
import store from '@/store';
import api from '@/services';

// Set user data to local storage
export const localStorageUserSetUp = async () => {
  const lsUser = Vue.ls.get('user');
  const lsToken = Vue.ls.get('token');
  const lsStompConfig = Vue.ls.get('stompConfig');
  const lsGameState = Vue.ls.get('gameState');

  if (lsToken && lsUser) {
    api.User.setToken(lsToken);
    store.dispatch('setUserData', lsUser);

    store.dispatch('toggleProcessing', true);

    const { user, gameState, config } = await store.dispatch('getUserData');

    // STOMP CONFIG
    Vue.ls.set('stompConfig', config);
    store.dispatch('setStompConfig', config);

    // ACTIVE GAME STATE
    Vue.ls.set('gameState', gameState);
    store.dispatch('setGameState', gameState);

    // USER DATA
    Vue.ls.set('user', user);
    store.dispatch('setUserData', user);

    // store.dispatch('getApiVersion');
  }
  store.dispatch('toggleProcessing', false);
};
